/* tslint:disable */
/* eslint-disable */
/**
 * The Thing API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    ProblemDetails,
    ProblemDetailsFromJSON,
    ProblemDetailsToJSON,
    UpdateVaultedInterrogatoryRequest,
    UpdateVaultedInterrogatoryRequestFromJSON,
    UpdateVaultedInterrogatoryRequestToJSON,
    VaultSearchResponse,
    VaultSearchResponseFromJSON,
    VaultSearchResponseToJSON,
    VaultedInterrogatory,
    VaultedInterrogatoryFromJSON,
    VaultedInterrogatoryToJSON,
} from '../models';

export interface VaultSearchVaultRequest {
    documentId?: string;
    interrogatoryId?: number;
    term?: string;
}

export interface VaultUpdateInterrogatoryRequest {
    id: string;
    updateVaultedInterrogatoryRequest?: UpdateVaultedInterrogatoryRequest;
}

/**
 * 
 */
export class VaultApi extends runtime.BaseAPI {

    /**
     */
    async vaultSearchVaultRaw(requestParameters: VaultSearchVaultRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<VaultSearchResponse>> {
        const queryParameters: any = {};

        if (requestParameters.documentId !== undefined) {
            queryParameters['documentId'] = requestParameters.documentId;
        }

        if (requestParameters.interrogatoryId !== undefined) {
            queryParameters['interrogatoryId'] = requestParameters.interrogatoryId;
        }

        if (requestParameters.term !== undefined) {
            queryParameters['term'] = requestParameters.term;
        }

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Vault/search`,
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VaultSearchResponseFromJSON(jsonValue));
    }

    /**
     */
    async vaultSearchVault(requestParameters: VaultSearchVaultRequest, initOverrides?: RequestInit): Promise<VaultSearchResponse> {
        const response = await this.vaultSearchVaultRaw(requestParameters, initOverrides);
        return await response.value();
    }

    /**
     */
    async vaultUpdateInterrogatoryRaw(requestParameters: VaultUpdateInterrogatoryRequest, initOverrides?: RequestInit): Promise<runtime.ApiResponse<VaultedInterrogatory>> {
        if (requestParameters.id === null || requestParameters.id === undefined) {
            throw new runtime.RequiredError('id','Required parameter requestParameters.id was null or undefined when calling vaultUpdateInterrogatory.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        headerParameters['Content-Type'] = 'application/json';

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/api/Vault/interrogatories/{id}`.replace(`{${"id"}}`, encodeURIComponent(String(requestParameters.id))),
            method: 'PUT',
            headers: headerParameters,
            query: queryParameters,
            body: UpdateVaultedInterrogatoryRequestToJSON(requestParameters.updateVaultedInterrogatoryRequest),
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => VaultedInterrogatoryFromJSON(jsonValue));
    }

    /**
     */
    async vaultUpdateInterrogatory(requestParameters: VaultUpdateInterrogatoryRequest, initOverrides?: RequestInit): Promise<VaultedInterrogatory> {
        const response = await this.vaultUpdateInterrogatoryRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
